define('responsive-gameday/views/Monitor/ViewModels/VideoViewModel',['require','exports','module','./ViewModelBase','GameDayCore','jquery','../Events/ViewModelUpdateEvents','../Events/SceneStateEvents','extant/extant','message-service/message-service','GameDayCore/GDModel/enums/datasources/Datasources'],function(require,exports,module) {
    var ViewModelBase = require("./ViewModelBase"),
        GDC = require("GameDayCore"),
        $ = require("jquery"),
        UpdateEvents = require("../Events/ViewModelUpdateEvents"),
        SceneStates = require("../Events/SceneStateEvents"),
        exists = require("extant/extant"),
        MessageService = require("message-service/message-service"),
        Datasources = require("GameDayCore/GDModel/enums/datasources/Datasources");
    var Superclass;

    function VideoViewModel() {
        Superclass.constructor.call(this);
        this.eventType = UpdateEvents.UPDATE_VIDEO;
        MessageService.addListener.call(this, UpdateEvents.REQUEST_VIDEO_DATA, this.handleUpdateRequest);
    }

    ViewModelBase.spawn(VideoViewModel).define({
        moldData: function(flavor) {
            // Removing this check for now... scene state is updated out of cycle with the tertiary data loads
            // if (!exists(this.stateUpdates, SceneStates.NEW_VIDEO_HIGHLIGHTS)) {
            //     return;
            // };

            var gameVideoData = this.gameData.video,
                gotsum = (exists(gameVideoData, "videosArray"));
            this.dataPack = {};

            // present blank if theres no videos to d-d-d-display instead of getting stuck on the render.
            this.dataPack = {
                videosById : (gotsum) ? gameVideoData.videosBySVID : {},
                hasVideos: (gotsum) ? gameVideoData.hasVideos : false,
                videos: (gotsum) ? gameVideoData.videosArray : []
            };

            // get the num of new vids then build data pack of just new videos... maybe
            this.dispatchUpdates(this.eventType, this.dataPack);
        },

        handleUpdateRequest: function() {
            var that = this;
           MessageService.one.call(that, GDC.requestGameData(Datasources.VIDEO), function(payload, evt) {
               that.gameData = payload;
               that.stateUpdates[SceneStates.NEW_VIDEO_HIGHLIGHTS] = true;
               that.moldData(Datasources.VIDEO);
           });
        }
    });

    Superclass = VideoViewModel.superclass;

    return VideoViewModel;
});
